export const noOfDigitsAfterDecimal = (num) => {
  if (Number.isInteger(num)) {
    return 0;
  }

  return num.toString().split(".")[1].length;
};

export const limitDecimalPlacesIfExceed = (val, decimalPlacesLimit) => {
  let parsedValue = parseFloat(val);
  if (isNaN(parsedValue)) return "";

  return noOfDigitsAfterDecimal(parsedValue) > decimalPlacesLimit ? parsedValue.toFixed(decimalPlacesLimit) : parsedValue;
};



// WEBPACK FOOTER //
// ./src/utils/numberUtils.js